import isUUID from 'validator/lib/isUUID';
import uuidv4 from 'uuid/v4';
import ky from 'ky-universal';

import extendOrSetCookie from '../extendOrSetCookie';
import getGeneralFields from './getGeneralFields';

import {
  COOKIE_CROSS_DOMAIN,
  COOKIE_LOG_TRACKING_CLIENT_ID,
  COOKIE_LOG_TRACKING_CLIENT_ID_AGE,
  COOKIE_LOG_TRACKING_SESSION_ID,
  COOKIE_LOG_TRACKING_SESSION_ID_AGE,
  TRACKING_EVENT__INIT_SESSION,
  TRACKING_OPERATION__SYSCTL,
  TRACKING_API_ENDPOINT,
  IS_SUPPORT_SAME_SITE_NONE_COOKIE,
  IS_DEV,
} from '../../../constants';

/**
 * 送出其他事件前，嘗試延長 session 效期；
 * 如果 session 不存在則生成新的，並發送 init_session 事件
 */
export default async function extendOrInitSession() {
  // 延長 installation_id 效期
  extendOrSetCookie(COOKIE_LOG_TRACKING_CLIENT_ID, {
    shouldExtend: isUUID,
    getNewValue: uuidv4,
    cookieAttributes: {
      expires: COOKIE_LOG_TRACKING_CLIENT_ID_AGE,
      domain: COOKIE_CROSS_DOMAIN,
      sameSite: !IS_DEV && IS_SUPPORT_SAME_SITE_NONE_COOKIE ? 'None' : undefined,
      secure: !IS_DEV,
    },
  });

  // 延長 session_id 效期
  const updateSessionResult = extendOrSetCookie(COOKIE_LOG_TRACKING_SESSION_ID, {
    shouldExtend: isUUID,
    getNewValue: uuidv4,
    cookieAttributes: {
      expires: COOKIE_LOG_TRACKING_SESSION_ID_AGE,
      domain: COOKIE_CROSS_DOMAIN,
      sameSite: !IS_DEV && IS_SUPPORT_SAME_SITE_NONE_COOKIE ? 'None' : undefined,
      secure: !IS_DEV,
    },
  });

  // 發送 init_session 事件
  if (!updateSessionResult.isExtended && updateSessionResult.value) {
    /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=744606520} */
    const payload = {
      ...getGeneralFields(),
      event: TRACKING_EVENT__INIT_SESSION,
      op: TRACKING_OPERATION__SYSCTL,
      op_meta: {
        language: navigator.language || navigator.userLanguage,
        width: screen.width,
        height: screen.height,
        // dpi: undefined,
        // brand: undefined,
        // model: undefined,

        user_agent: navigator.userAgent,
        // carrier: undefined,
        // connection: undefined,
      },
    };

    await ky.post(TRACKING_API_ENDPOINT, { json: payload, throwHttpErrors: false });
  }
}
